<template>
  <div class="shop-live">
    <div>
      <span class="buttons is-centered single-line gpu-accelerated">
        <span style="padding-left:4px" />
        <span style="margin:5px">
          <img src="../assets/question_marks.png" class="pulse" />
        </span>
        <span v-for="b in businesses" :key="b.id" style="margin:5px">
          <img v-webp="businessProfilePic(b)" @error="defaultImg" @click="goto(`shop/${b.id}`)" />
        </span>
        <span style="padding-right:4px" />
      </span>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";

export default {
  name: "ShopLive",
  data() {
    return {
      selected: null,
      sortBy: "alphabet",
    };
  },
  computed: {
    businesses() {
      var shops = this.$store.getters.getShops;
      if (this.selected) {
        var filtered = shops.filter((b) => b.business_type === this.selected);
        return filtered;
      }
      if (this.sortBy === "alphabet") return this.sortAlphabet(shops, "name");
      if (this.sortBy === "category")
        return this.sortAlphabet(shops, "business_type");
      return shops; // else return all
    },
  },
  mounted() {
    EventBus.$on("SHOP_LIST_SORT", (type) => (this.sortBy = type));
  },
  methods: {
    defaultImg(e) {
      e.target.src = this.$store.state.menuItemPlaceholderPic;
    },
    sortAlphabet(arr, field) {
      return arr.sort((a, b) => {
        var textA = a[field].toUpperCase();
        var textB = b[field].toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
    },
    businessProfilePic(b) {
      if (b.profile_pic_url) return b.profile_pic_url;
      return "https://i.ibb.co/DK0f6y3/TUK-Esssentials-profile.png";
    },
    // if promo go to shop promo tab
    openShopPage(businessID) {
      this.$store.commit("selectBusiness", businessID);
      this.$router.push(`/shop/${businessID}`);
    },
    // // if live go to facebook link << test code, was not implemented yet
    // goToLiveLink(i) {
    //   var url = `https://www.facebook.com/Daiso.Sushi/videos/641632749730609/`; // daiso live
    //   if (i % 2 == 0) {
    //     url = `https://www.facebook.com/tukapp/posts/234537317931630`; // tuk post
    //   }
    //   setTimeout(() => window.open(url, "_blank"), 500);
    //   // if (this.isIOSApp()) window.location.href = url;         // hack for ios app
    // }
  },
};
</script>

<style scoped>
.buttons {
  width: 100vw;
  padding-top: 6px;
}
.single-line {
  white-space: nowrap;
  overflow: auto;
  margin-bottom: -10px;
  display: inline-block;
}
img {
  border-radius: 50%;
  /* background: url("../assets/live-stripes.jpg");
  padding: 2px;
  object-fit: cover; */
  height: 60px;
  width: 60px;
  /* border: 3px solid #f5d252; */
  border: 1px solid white;
  /* box-shadow: 0 0 0 2pt #f5d252; */
  box-shadow: 0 0 0 2pt #f5d252, 2px 2px 4px rgba(0, 0, 0, 0.35);
}
.dark img {
  /* border: 3px solid #2693da; */
  border: 1px solid #123;
}
img:active {
  transform: rotate(340deg);
  -webkit-transform: rotate(340deg);
  -ms-transform: rotate(340deg);
}
.buttons::-webkit-scrollbar {
  display: none;
}
.pulse {
  animation: shadow-pulse 1s infinite;
}
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px cyan;
  }
  100% {
    box-shadow: 0 0 0 6px rgba(0, 255, 255, 0.445);
  }
}
/* span img {
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.35);
} */
</style>